import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or default to Arabic
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('app_language');
    return saved || 'ar';
  });

  // Update localStorage and document direction when language changes
  useEffect(() => {
    localStorage.setItem('app_language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations['ar']?.[key] || key;
  };

  // Toggle between Arabic and German
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'de' : 'ar');
  };

  // Set specific language
  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  // Check if current language is RTL
  const isRTL = language === 'ar';

  const value = {
    language,
    setLanguage: changeLanguage,
    toggleLanguage,
    t,
    isRTL,
    translations: translations[language]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
